import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthContractComponent } from './auth-contract/auth-contract.component';
import { RegisterComponent } from './register/register.component';
import { RegisterUserComponent } from './register-user/register-user.component';
import { RegisterUserQuestionComponent } from './register-user-question/register-user-question.component';
import { RegisterUserMessageComponent } from './register-user-message/register-user-message.component';
import { LoginMpComponent } from './login-mp/login-mp.component';


const authRoutes: Routes = [
    {
      path: '',
      component: AuthComponent,
      children: [
        {
          path: '',
          children: [
            { path: 'sign_in', component: LoginComponent },
            { path: 'sign_in?id=1', component: LoginComponent },
            { path: 'mp_access', component: LoginMpComponent },
            { path: 'forgot_password', component: ForgotPasswordComponent },
            { path: 'register', component: RegisterComponent },
            { path: 'register/user', component: RegisterUserComponent },
            { path: 'register/user/questions', component: RegisterUserQuestionComponent },
            { path: 'register/user/message', component: RegisterUserMessageComponent },
            { path: 'contract', component: AuthContractComponent },
            { path: '', component: LoginComponent }
          ]
        }
      ]
    }
  ];
  
  @NgModule({
    imports: [
      RouterModule.forChild(authRoutes)
    ],
    exports: [
      RouterModule
    ]
  })
  export class AuthRoutingModule {}


// WEBPACK FOOTER //
// /app/src/app/auth/auth-routing.module.ts